import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Landing target of the Google OAuth redirect. The API puts the freshly minted
 * tokens in the URL fragment (never sent to the server); we adopt them into the
 * session and continue to the dashboard.
 */
export function OAuthCallbackPage() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const access = params.get('access');
    const refresh = params.get('refresh');
    if (access && refresh) {
      setSession(access, refresh);
      // Drop the tokens from the address bar, then land on the dashboard.
      window.history.replaceState(null, '', '/oauth');
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/login?error=google', { replace: true });
    }
  }, [navigate, setSession]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default' }}>
      <Stack spacing={2} alignItems="center">
        <CircularProgress />
        <Typography color="text.secondary">Signing you in…</Typography>
      </Stack>
    </Box>
  );
}
